import * as React from 'react';
import { useState } from 'react';
import { UserIcon } from '@patternfly/react-icons';
import {
  Breadcrumb,
  BreadcrumbItem,
  Content,
  Icon,
  PageBreadcrumb,
  PageSection,
  PageSectionVariants,
  Tab,
  TabTitleText,
  Tabs,
} from '@patternfly/react-core';
import { useAuth } from 'react-oidc-context';
import Unauthenticated from '@app/Unauthenticated';
import ProfileForm from './ProfileForm';
import PreferencesForm from './PreferencesForm';

function Profile() {
  const auth = useAuth();
  const [activeTab, setActiveTab] = useState<string | number>(0);

  if (!auth.isAuthenticated) {
    return <Unauthenticated />;
  }

  return (
    <>
      <PageBreadcrumb hasBodyWrapper={false} hasShadowBottom={false}>
        <Breadcrumb ouiaId="BasicBreadcrumb">
          <BreadcrumbItem isActive>Profile</BreadcrumbItem>
        </Breadcrumb>
      </PageBreadcrumb>
      <PageSection
        hasBodyWrapper
        type="default"
        variant={PageSectionVariants.default}
        isWidthLimited
        hasShadowBottom={true}
      >
        <Content component="h1">
          <Icon size="lg" style={{ marginRight: '8px' }}>
            <UserIcon />
          </Icon>
          User Profile
        </Content>
        <Content component="p">Review your account information and manage your personal preferences.</Content>
      </PageSection>

      <PageSection hasBodyWrapper={false}>
        {/* mountOnEnter: the Preferences tab fetches its own data (GET /users/me/preferences),
            so defer that request until the tab is first opened (CLAUDE.md detail-tab rule). */}
        <Tabs
          activeKey={activeTab}
          onSelect={(_event, tabKey) => setActiveTab(tabKey)}
          aria-label="Profile sections"
          mountOnEnter
        >
          <Tab eventKey={0} title={<TabTitleText>Profile</TabTitleText>}>
            <div className="pf-v6-u-pt-md">
              <ProfileForm />
            </div>
          </Tab>
          <Tab eventKey={1} title={<TabTitleText>Preferences</TabTitleText>}>
            <div className="pf-v6-u-pt-md">
              <PreferencesForm />
            </div>
          </Tab>
        </Tabs>
      </PageSection>
    </>
  );
}

export { Profile };
